import { HttpAuth } from '../../config/Http'
import { changeLoading } from './loading.action';
import { changeNotify } from './notify.action';
import { change as changeVerifySms } from './sms.action'

export const actionTypes = {
    INDEX: 'USUARIOS_INDEX',
    RIFAS: 'USUARIOS_RIFAS',
    BILHETES: 'USUARIOS_BILHETES',
    UPDATE: 'BILHETES_UPDATE'
};

export const indexResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const index = (query, isLoadMore = null) => dispatch => {
    return HttpAuth.get('/usuarios?'+ new URLSearchParams(query))
        .then(res => res && dispatch(indexResponse(res.data, isLoadMore)))
        .catch(error => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof error.response !== 'undefined') {
                if(error.response.status === 400) {
                    if(typeof error.response.data === 'object'){
                        if(typeof error.response.data.error_code !== undefined) {
                            dispatch(changeVerifySms({
                                open: true,
                                screen_id: 'users.index'
                            }))
                            
                            return false
                        }
                        
                        if(typeof error.response.data.error !== undefined) {
                            if(typeof error.response.data.error === 'string'){
                                dispatch( changeNotify({
                                    open: true,
                                    class: 'error',
                                    msg: error.response.data.error
                                }))
                            }
                        }
                    }
                }
            }
        })
}